﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button as BPButton, Intent } from "@blueprintjs/core";
import './Buttons.css';

export function Button(
    {
        id = null,
        intent = "",
        loading = false,
        disabled = false,
        icon = null,
        iconOnly = false,
        text = "",
        minimal = false,
        large = true,
        small = false,
        alignText = null,
        rightIcon = null,
        className,
        onClick
    }
) {

    let intentValue = Intent.NONE;
    if (intent) {
        switch (intent.toLowerCase()) {
            case "save":
            case "info":
            case "primary":
                intentValue = Intent.PRIMARY;
                break;
            case "warning":
                intentValue = Intent.WARNING;
                break;
            case "danger":
            case "delete":
                intentValue = Intent.DANGER;
                break;
            case "secondary":
                intentValue = "secondary"
                break;
            case "success":
                intentValue = Intent.SUCCESS;
                break;
            default:
                intentValue = Intent.NONE;
        }
    }

    let size;
    if (large) {
        size = "large";
    } else if (small) {
        size = "small";
    }

    let variant;
    if (minimal) {
        variant = "minimal";
    }

    return (
        <BPButton
            className={classNames('btn-form', { "bp6-skeleton": loading }, className)}
            onClick={onClick}
            icon={icon}
            disabled={disabled}
            variant={variant}
            size={size}
            intent={intentValue}
            id={id}
            alignText={alignText}
            endIcon={rightIcon}
        >{!iconOnly && text}</BPButton>
    );
}

Button.propTypes = {
    id: PropTypes.string,
    intent: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconOnly: PropTypes.bool,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    minimal: PropTypes.bool,
    large: PropTypes.bool,
    className: PropTypes.string,
    alignText: PropTypes.string,
    rightIcon: PropTypes.string
};